import React,{Component} from 'react';
import Header from '../../components/Navigation/Header/Header';
import Footer from '../../components/Navigation/Footer/Footer';
import Sidedrawer from '../../components/Navigation/Sidedrawer/Sidedrawer';
import Backdrop from '../../components/UI/Backdrop/Backdrop';
import Auxi from '../Auxi/Auxi';



class Layout extends Component {
    state = {
        sideDrawer:false
    }

    render() {
        return (<Auxi>
            <Header burgerClicked={this.updateDrawerHandler} />
            <Backdrop clicked={this.updateDrawerHandler} show={this.state.sideDrawer} />
            <Sidedrawer show={this.state.sideDrawer} />
            {this.props.children}
            <Footer/>
        </Auxi>);
    }


    updateDrawerHandler = () => {
        const sideDrawerPrevState = this.state.sideDrawer;
        this.setState({sideDrawer:!sideDrawerPrevState})
    }
}

export default Layout;


// WEBPACK FOOTER //
// ./src/hoc/Layout/Layout.js